import { axiosPortalInstance } from '@mais-retorno-front/configs/axios-config';

export const getRetornoAdss = async (): Promise<GetRetornoAdssOutput> => {
  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
        query retornoAd {
          retornoAd {
            data {
              attributes {
                search_cnpj
                cnpj_1
                cnpj_2
                cnpj_3
                cnpj_4
              }
            }
          }
        }
        `,
      },
    });

    const { cnpj_1, cnpj_2, cnpj_3, cnpj_4, search_cnpj }: IResponse =
      data?.data?.retornoAd?.data.attributes;

    const cnpjList = [cnpj_1, cnpj_2, cnpj_3, cnpj_4]
      .filter(Boolean)
      .map((cnpj) => cnpj.replace(/\D/g, ''));

    return { search_cnpj, cnpjList };
  } catch (err) {
    return null;
  }
};

interface IResponse {
  cnpj_1: string | null;
  cnpj_2: string | null;
  cnpj_3: string | null;
  cnpj_4: string | null;
  search_cnpj: string | null;
}

interface GetRetornoAdssOutput {
  search_cnpj: string | null;
  cnpjList: string[];
}
